module.exports = __webpack_public_path__ + "static/img/xinxihua2.1f455842.png";